import { cloneDeep } from 'lodash-es'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { getOpBelong, hasPermission } from '@/data/permission'
import type { SubMenuType } from '@/data/permission'
import { UserInfoType, useUserInfo } from '@/store'
import { getToken } from '@/utils'
import { getCurrentRegion } from '@/utils/storage'
import { constantRoutes, dynameicRoutes, errRoute, whiteRoutes } from './routerMap'
export type RowMeta = {
  meta: {
    title: string
    hidden?: boolean
    icon?: string
  }
  children?: Array<RowMeta>
} & RouteRecordRaw

const router = createRouter({
  history: createWebHashHistory(),
  routes: [...whiteRoutes, ...constantRoutes],
})

const filterAsyncRoutes = (routes: Array<RowMeta>, userInfo: UserInfoType) => {
  const routerData = cloneDeep(routes)
  const root = routerData[0]
  console.log('routerDatarouterData', routerData)
  const region = getCurrentRegion()
  // console.log("regionregion", region)
  if (region === 'cn') {
    // routerData[0].children = routerData[0].children?.filter((item) => item.name !== "billing")
    // 1. 针对 billing 子路由过滤 myAccount 和 Billing records
    if (root) {
      root.children = (root.children ?? []).filter((item) => item.name !== 'billing')
    }
    // const billingMenu = routerData[0].children?.find((item) => item.name === "billing")
    // if (billingMenu && billingMenu.children) {
    //   billingMenu.children = billingMenu.children.filter((subItem) => subItem.name !== "myAccount" && subItem.name !== "rechargeRecord")
    // }
    // 2. 针对 message 子路由过滤 msgBilling
    const messageMenu = root?.children?.find((item) => item.name === 'message')
    if (messageMenu && messageMenu.children) {
      messageMenu.children = messageMenu.children.filter((subItem) => subItem.name !== 'msgBilling')
    }
  }
  if (userInfo?.is_main) {
    if (root) root.redirect = '/operations'
    return routerData
  } else {
    //获取有权限菜单名数组
    const menuArr = getOpBelong(userInfo?.permissions.map((item) => item.toString())) || []
    menuArr.push(['system', 'profile' as SubMenuType, false])
    menuArr.push(['message', 'msgSystem' as SubMenuType, false])
    menuArr.push(['message', 'msgAlarm' as SubMenuType, false])

    //过滤一级菜单
    const menus = (root?.children ?? []).filter((routeItem) =>
      menuArr.some((menuItem) => menuItem[0] === routeItem.name),
    )
    //过滤二级级菜单
    menus.map((menu) => {
      if (menu.children) {
        menu.children = menu.children.filter((subMenu) => {
          if (subMenu.name === 'apiManage') {
            return hasPermission('apiManage-view', userInfo)
          }
          return menuArr.some((menuItem) => menuItem[1] === subMenu.name)
        })
      }
    })

    // menus?.forEach((menu) => {
    //   if (menu.children) {
    //     menu.children = menu.children.filter((subMenu) => {
    //       const isDeviceOverview = subMenu.name === "deviceoverview"
    //       if (isDeviceOverview) {
    //         // deviceoverview 只有 is_main 才显示
    //         return userInfo?.is_main
    //       }
    //       return menuArr?.find((menuItem) => menuItem[1] === subMenu.name)
    //     })
    //   }
    // })

    if (root) root.children = menus
    const hasControlpanel = menuArr.find((item) => item[1] === 'controlpanel')
    if (hasControlpanel) {
      if (root) root.redirect = '/operations'
    } else {
      if (root) root.redirect = '/system'
    }

    return routerData || constantRoutes
  }
}

const whiteNames = whiteRoutes.map((item) => item.name)

router.beforeEach(async (to, from, next) => {
  window.$loading.start()
  const token = getToken()
  const userStore = useUserInfo()
  if (whiteNames.includes(to.name as string)) {
    return next()
  }
  if (!token) {
    return next('/login')
  }

  if (userStore.menuList.length === 0) {
    await userStore.getUserInfo()
    await userStore.getMsgCount()

    const menus = filterAsyncRoutes(dynameicRoutes, userStore.userInfo as UserInfoType)
    router.removeRoute('index')
    menus.map((route) => {
      router.addRoute(route)
    })
    if (router.hasRoute('notFound')) {
      router.removeRoute('notFound')
    }
    router.addRoute(errRoute)

    userStore.setMenuList(menus)

    const redirectPath = menus[0].redirect as string
    // 仅当用户访问的是根路径 "/" 时才重定向到仪表盘；刷新时 to 为当前 URL，应保留当前页
    if (from.path === '/' && to.path === '/') {
      const operations = menus[0].children?.find((path) => path.name === 'operations')
      const dashboard = operations?.children?.find((item) => item.name === 'dashboard')
      const controlpanel = operations?.children?.find((item) => item.name === 'controlpanel')

      if (dashboard) {
        return next({ path: dashboard.path, query: to.query, replace: true })
      } else if (controlpanel) {
        return next({ path: controlpanel.path, query: to.query, replace: true })
      } else {
        return next({ path: '/system/profile', query: to.query, replace: true })
      }
    }
    if (from.name === 'login') {
      return next({ path: redirectPath, query: to.query, replace: true })
    }
    // 刷新或从其他页进入时保留目标路由（当前页）
    return next({ ...to, replace: true })
  }
  return next()
})

router.afterEach((to) => {
  window.$loading.finish()
  document.title = `${to.meta.title}`
})

router.onError((error) => {
  console.log(error)
})

export default router
